import {CREATE_USER, FIND_ALL_USERS, DELETE_ONE_USER, UPDATE_ONE_USER, FIND_ONE_USER} from '../actions/user'

const initialState = {
    user: {}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE_USER:
            return state
        case FIND_ALL_USERS:
            return action.payload
        case DELETE_ONE_USER:
            return state
        case UPDATE_ONE_USER:
            return action.payload
        case FIND_ONE_USER:
            return action.payload
        default:
            return state
    }
}
